export default {
	"INITED": "inited",
	"FILE_SELECTED": "fileSelected",
	"UPLOAD_STARTED": "uploadStarted",
	"LOAD_PROGRESS": "loadProgress",
	"LOAD_COMPLETE": "loadComplete",
	"UPLOAD_PROGRESS": "uploadProgress",
	"UPLOAD_COMPLETE": "uploadComplete",
	"UPLOAD_ERROR": "uploadError",
	"UPLOAD_STOP": "uploadStop",
	"INVALID_FILE": "invalidFile",
	"UPLOADED": "uploaded",
	"UPLOADING": "uploading",
	"IO_ERROR": "ioError"
};
